export const environment = {
    production: true,

    //*************PRODUCTION Databases and Environments*************
    appAPIUrl: 'https://harrellspublicapi.azurewebsites.net/api',
    //appAPIUrl: 'https://localhost:44300/api',

    appAPIUrlRoot: 'harrellspublicapi.azurewebsites.net/',

    //harfilesAPIUrl: 'https://localhost:44372/api',
    //harfilesAPIUrl: 'https://harfilerepositoryapitest.azurewebsites.net/api',
    harfilesAPIUrl: 'https://harfilerepositoryapi.azurewebsites.net/api',

    notificationsAPIUrl: 'https://harnotificationsapi.azurewebsites.net/api',

    appDomainURL: 'https://harrellspublic2024.azurewebsites.net/',

    azureBlobStorageURL: 'https://harrellscom.blob.core.windows.net/harrellscom/',
    baseImagesFilePathBlobStorage: 'assets/images',
    baseFormsFilePathBlobStorage: 'assets/forms',
    baseFilesPathBlobStorage: 'assets/files'

};
